import request from "@/utils/request";

//用户列表
export function rolesList(params) {
  return request({
    url: "/api/admin/roles",
    method: "get",
    params
  });
}

//权限列表 admin_role_manage
export function rolesTree() {
  return request({
    url: "/api/admin/role/create",
    method: "get"
  });
}

//创建角色
export function createRole(data) {
    return request({
      url: "/api/admin/role/create",
      method: "post",
      data
    });
  }

//删除角色
export function deleteRole(id) {
    return request({
      url: "/api/admin/role/"+id+"/delete",
      method: "post"
    });
  }

//获取角色的权限
export function getRolePermission(id) {
  return request({
    url: "/api/admin/role/"+id+"/edit",
    method: "get"
  });
}

//设置角色的权限
export function editRolePermission(id,data) {
  return request({
    url: "/api/admin/role/"+id+"/edit",
    method: "post",
    data
  });
}

//检查角色名重复
export function checkRoleName(params) {
  return request({
    url: "/api/admin/role/checkName",
    method: "get",
    params
  });
}

//检查角色code重复
export function checkRoleCode(params) {
  return request({
    url: "/api/admin/role/checkCode",
    method: "get",
    params
  });
}


